export class PrinterType {
    private static _values = new Array<PrinterType>()

    public static readonly LASER_PRINTER = new PrinterType(1, "レーザープリンター用");
    public static readonly INKJET_PRINTER = new PrinterType(2, "インクジェットプリンター用");
    public static readonly FAX = new PrinterType(3, "FAX用");
    public static readonly COPY = new PrinterType(4, "コピー用");
    public static readonly DOT_PRINTER = new PrinterType(5, "ドットプリンター用");
    public static readonly LIGHT_PRINTING_MACHINE = new PrinterType(6, "軽印刷機用");

    private constructor(
      public readonly code: number,
      public readonly name: string,
    ) { 
        PrinterType._values.push(this);
    }
  
    static get values() {
      return this._values;
    }
  
    static fromCode(code: number) {
      return this.values.find(printerType => printerType.code === code);
    }
  
    equals(other: PrinterType) {
      return this.code === other.code;
    }
  
    toString() {
      return `${this.code}(${this.name})`;
    }
  
}